module.exports = __webpack_public_path__ + "img/kypho 480x480.f972c079.png";